export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024; // 5 MB
